// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__3I6IG"};